<rid-word-path
  class="h-dvh"
  [startWord]="['l', 'eeuw']"
  [path]="[
    {
      word: ['m', 'eeuw'],
      image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9VBB1feXs2LpahqHeUjcI.png',
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/fk7dpgpsF2pHlAe0cD_pz.mp3',
    },
    {
      word: ['m', 'ij'],
      image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/BU42wka8fmT7b-tfcJz7k.png',
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/o2A0SyPiYEQGxBHEQm__W.mp3',
    },
    {
      word: ['m', 'oe'],
      image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/cPJ43Mg3wbqaC4b_4vy0C.png',
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/95ZZU-VbZagMvAKGbFPzq.mp3',
    },
    {
      word: ['b', 'oe'],
      image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/ItA7z8v8WYqsGE1Dbgj5C.png',
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/Bg7dzNxsX6n2izYD6Q2dU.mp3',
    },
    {
      word: ['b', 'oe', 'm'],
      image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/7pFtgnpg4_ewwuToe9r88.png',
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/Y39n4J2WswZ3BnuScDiVu.mp3',
    },
    {
      word: ['b', 'l', 'oe', 'm'],
      image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/ujU1u3cd3vJBl8ow7d3Qc.png',
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/k8rhBR8M1PrdwlWcGttq9.mp3',
    },
  ]"
  (finished)="$router.navigate(['/mechanics/phonetic-comprehension'])"
/>
